import './App.css';
import {
    Box,
    Drawer,
    Toolbar,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Avatar,
    IconButton
} from '@mui/material';
import {
    Apps,
    Hub as Subnet,
    Dns as Server,
    Add,
    Close,
    ArrowBack,
    InstallMobile, AddCircle, AddCircleOutlineOutlined, Store, Storefront,
} from '@mui/icons-material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import * as React from "react";
import {isInIframe, isMobile, kbIdToSubdomainUrl, parseKBSubdomain, getTargetDomain, getParkedDomain} from "./utils.js";
import {useState} from "react";
import Divider from "@mui/material/Divider";
import {getKBImage} from "../KB/KBImage";
import {deleteRecentApp, getBaseUrl, getRecentApps, updateRecentApps} from "../utils";
import LocalLoader from "../Loaders/LocalLoader";
import {ChatsList} from "./ChatsHistory";
import {KBName, KBNamePlural} from "../names";

// Left Menu
export function LeftMenu({ open, drawerWidth, handleDrawerClose, tabStyle, network, pathSegments, kbSubdomain,
                           kbChats, setKBChats, navigateToChat, isStreaming, unreadMessages, ChatData, setChatData,
                             renderSettings, loadMoreChats, hasMoreChats, loadingMore, userProfile
                         }) {
    const navigate = useNavigate();
    const location = useLocation();
    const firstPathSegment = location.pathname.split('/')[1] || '';
    const [recentApps, setRecentApps] = useState(getRecentApps());
    const [loading, setLoading] = useState(false);

    const tabStyleChat = {
        height: '35px',
        minWidth: '100%',
        justifyContent: 'flex-start',
        marginLeft: '0px',
    };

    const baseStyle = {
        '.MuiListItemIcon-root': {
            minWidth: '40px',
            marginRight: '8px'
        },
        '.MuiListItemText-primary': {
            fontWeight: 'normal'
        },
        margin: '8px 15px',
        padding: '5px 10px',
        borderRadius: '5px',
    }

    const handleNavigateWrapper = (event, path, forceBlank) => {
        event.preventDefault();
        let myPath = path;
        if (myPath === '/' || !myPath) myPath = '/dashboard';
        const baseUrl = getBaseUrl();
        if (forceBlank || event?.ctrlKey || event?.metaKey || path === '/tutorials') {
            // Open in a new tab if Ctrl or Meta (Cmd on Mac) is pressed
            window.open(baseUrl + myPath, '_blank');
        } else {
            if (kbSubdomain) {
                window.location.href = baseUrl + myPath;
            } else {
                handleNavigate(myPath);
            }

        }
    }

    const handleNavigate = (path, event) => {
        if (event?.ctrlKey || event?.metaKey) {
            window.open(path, '_blank');
        } else {
            const { kbIdAsSubdomain, mainDomain, protocol } = parseKBSubdomain() || {};
            if (kbIdAsSubdomain) {
                const targetDomain = getTargetDomain(mainDomain);
                window.location.href = `${protocol}//${targetDomain}` + path;
            } else {
                navigate(path, { replace: true });
            }
            if (isMobile) {
                handleDrawerClose();
            }
        }
    };

    const listItemTextStyle = {
        '.MuiListItemText-primary': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '0.875rem'
        },
    };

    const handleDeleteRecentApp = (e, kbId) => {
        e.stopPropagation();
        e.preventDefault()
        deleteRecentApp(kbId);
        setRecentApps(prev => prev.filter(app => app.kbId !== kbId));
    };

    return (
        <Drawer
            variant="persistent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                [`& .MuiDrawer-paper`]: { width: drawerWidth, boxSizing: 'border-box' },
            }}
            open={open}
        >
            <Toolbar />
            <LocalLoader open={loading} blocking={true} />
            <Box sx={{ overflow: 'auto', position: 'relative', height: '100%' }}>
                <List>
                    {!kbSubdomain && <>
                        <ListItemButton
                            disableRipple
                            selected={!kbSubdomain && firstPathSegment === '/dashboard'}
                            onClick={(e) => handleNavigateWrapper(e, '/dashboard')}
                            sx={tabStyle}
                        >
                            <ListItemIcon>
                                <Apps />
                            </ListItemIcon>
                            <ListItemText primary={!getParkedDomain() ? "Dashboard" : "My " + KBNamePlural} />
                        </ListItemButton>

                        {getParkedDomain() && <ListItemButton
                            disableRipple
                            selected={!kbSubdomain && location.pathname.includes('/app-center')}
                            onClick={(e) => handleNavigateWrapper(e, '/app-center')}
                            sx={tabStyle}
                        >
                            <ListItemIcon><Storefront /></ListItemIcon>
                            <ListItemText primary="Marketplace" />
                        </ListItemButton>}
                    </>}

                    {kbSubdomain
                        ? <>
                            <ListItemButton
                                disableRipple
                                style={{ display: (isInIframe() ? 'none' : undefined) }}
                                selected={false}
                                onClick={(e) => handleNavigateWrapper(e, '/dashboard', isInIframe())}
                                sx={tabStyle}
                            >
                                <ListItemIcon>
                                    <ArrowBack />
                                </ListItemIcon>
                                <ListItemText primary={"Back to " + KBNamePlural} />
                            </ListItemButton>
                            {/*<Divider textAlign="center" style={{ margin: '24px 16px 24px 16px' }}>Chat List</Divider>*/}
                            <ChatsList {...{kbChats, setKBChats, isStreaming, navigateToChat, unreadMessages, ChatData, setChatData, renderSettings, loadMoreChats, hasMoreChats, loadingMore}} />
                          </>
                        : null}

                    {network?.map((net, index) => (
                        <React.Fragment key={index}>
                            <ListItemButton
                                disableRipple
                                // selected={pathSegments[2] === encodeURIComponent(net.subnet)}
                                component={Link}
                                sx={{...tabStyle, pl: 4}}>
                                <ListItemIcon>
                                    <Subnet/>
                                </ListItemIcon>
                                <ListItemText primary={net.subnet}/>
                            </ListItemButton>

                            {net.servers.map((server, index) => (
                                <ListItemButton
                                    disableRipple
                                    selected={pathSegments[2] === net.subnet && pathSegments[3] === encodeURIComponent(server.url)}
                                    key={index}
                                    to={`/network/${encodeURIComponent(net.subnet)}/${encodeURIComponent(server.url)}`}
                                    component={Link} sx={{...tabStyle, pl: 6}}>
                                    <ListItemIcon>
                                        <Server/>
                                    </ListItemIcon>
                                    <ListItemText primary={server.url}/>
                                </ListItemButton>
                            ))}
                        </React.Fragment>
                    ))}
                </List>
            </Box>
        </Drawer>
    );
}